import { useContext } from 'react';
import { HotelContext } from '../contexts/HotelContext';
import { HotelContextInterface } from '../types/HotelContextTypes';

// A custom hook allows us to test better.
export const useHotelContext = () => useContext(HotelContext) as HotelContextInterface;

export default useHotelContext;
